import React, { useState, useEffect } from 'react';

const LoadingScreen = ({ message = 'Loading...', submessage = '' }) => {
  const [dots, setDots] = useState('');
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setDots(prev => prev.length >= 3 ? '' : prev + '.');
    }, 400);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress(prev => {
        if (prev >= 90) return prev;
        return prev + Math.random() * 15;
      });
    }, 300);
    return () => clearInterval(interval);
  }, []);

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #f5f5f5 0%, #e8e8e8 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontFamily: 'system-ui, -apple-system, sans-serif',
      padding: '20px'
    }}>
      <style>{`
        @keyframes pulse {
          0%, 100% { opacity: 1; transform: scale(1); }
          50% { opacity: 0.7; transform: scale(0.98); }
        }
        @keyframes shimmer {
          0% { background-position: -200% 0; }
          100% { background-position: 200% 0; }
        }
        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>

      <div style={{
        textAlign: 'center',
        animation: 'fadeInUp 0.5s ease-out'
      }}>
        <div style={{
          width: '80px',
          height: '80px',
          background: '#1a1a1a',
          borderRadius: '16px',
          margin: '0 auto 32px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          animation: 'pulse 2s ease-in-out infinite',
          boxShadow: '0 8px 32px rgba(0,0,0,0.12)'
        }}>
          <svg 
            style={{ width: '40px', height: '40px', color: 'white' }} 
            viewBox="0 0 24 24" 
            fill="none" 
            stroke="currentColor" 
            strokeWidth="2"
          >
            <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
            <line x1="9" y1="9" x2="15" y2="15" />
            <line x1="15" y1="9" x2="9" y2="15" />
          </svg>
        </div>

        <h1 style={{
          fontSize: '28px',
          fontWeight: '700',
          color: '#1a1a1a',
          marginBottom: '8px',
          letterSpacing: '-0.5px'
        }}>
          LIMAP
        </h1>

        <p style={{
          fontSize: '14px',
          color: '#888',
          marginBottom: '32px'
        }}>
          Local Image Mapping & Annotation Project
        </p>

        <div style={{
          width: '200px',
          height: '4px',
          background: '#e0e0e0',
          borderRadius: '2px',
          margin: '0 auto 16px',
          overflow: 'hidden'
        }}>
          <div style={{
            width: `${progress}%`,
            height: '100%',
            background: 'linear-gradient(90deg, #1a1a1a, #444, #1a1a1a)',
            backgroundSize: '200% 100%',
            animation: 'shimmer 1.5s linear infinite',
            borderRadius: '2px',
            transition: 'width 0.3s ease-out'
          }} />
        </div>

        <p style={{
          fontSize: '14px',
          color: '#666',
          minWidth: '150px'
        }}>
          {message}{dots}
        </p>

        {submessage && (
          <p style={{
            fontSize: '12px',
            color: '#999',
            marginTop: '8px'
          }}>
            {submessage}
          </p>
        )}
      </div>
    </div>
  );
};

export default LoadingScreen;